import Cookies from 'js-cookie';
const FEATURE_COOKIE_NAME = 'features';
const FEATURE_OVERRIDE_COOKIE_NAME = 'featureOverrides';
const SEPARATOR = ',';
const EXPIRY_DAYS = 30;
export const getFeatures = () => {
    const featureCookie = Cookies.get(FEATURE_COOKIE_NAME);
    return featureCookie ? featureCookie.split(SEPARATOR) : [];
};
export const setFeatures = (features) => {
    if (features && features.length) {
        Cookies.set(FEATURE_COOKIE_NAME, features.join(SEPARATOR), { expires: EXPIRY_DAYS });
    }
    else {
        Cookies.remove(FEATURE_COOKIE_NAME);
    }
};
export const getVisitorId = () => { var _a, _b; return (_b = (_a = Cookies.get('utag_main')) === null || _a === void 0 ? void 0 : _a.match(/v_id:([^$]*)/)) === null || _b === void 0 ? void 0 : _b[1]; };
export const getOverrides = () => {
    const featureQueryParam = new URLSearchParams(window.location.search).get('useFeatures');
    if (featureQueryParam) {
        Cookies.set(FEATURE_OVERRIDE_COOKIE_NAME, featureQueryParam, { expires: EXPIRY_DAYS });
    }
    const overrides = featureQueryParam || Cookies.get(FEATURE_OVERRIDE_COOKIE_NAME) || '';
    return overrides.split(',');
};
export default {
    getFeatures,
    setFeatures,
    getVisitorId,
    getOverrides,
};
